import React from 'react';
import { useIntl } from 'react-intl';
import { get, map } from 'lodash';
import cn from 'classnames';

import { MAPPING_PERIOD } from '../../../constants';
import type { MobileWidgetType } from '../../../types';
import './mobileHeader.scss';

interface Props {
    periods: MobileWidgetType[];
    activeZoneIndex: MobileWidgetType;
    makeHandleActiveZoneIndex: (zoneIndex: MobileWidgetType) => VoidFunction;
}

const MobileHeader: React.FC<Props> = ({
    periods,
    activeZoneIndex,
    makeHandleActiveZoneIndex,
}) => {
    const { formatMessage } = useIntl();

    return (
        <div styleName="container">
            {map(periods, type => {
                const period = get(MAPPING_PERIOD, type, undefined);

                return (
                    <div
                        key={type}
                        styleName={cn('item', {
                            'active-item': type === activeZoneIndex,
                        })}
                        onClick={makeHandleActiveZoneIndex(type)}
                    >
                        {period ? formatMessage(period) : type}
                    </div>
                );
            })}
        </div>
    );
};

export default React.memo(MobileHeader);
